import React from 'react';
import {Text, TextProps} from 'react-native';
import {useGlobalize} from 'react-native-globalize';
import AccountStore from 'src/stores/AccountStore';
type AVFormattedCurrencyProps = TextProps & {
  accessibilityLabel: string;
  prependedString?: string;
  value: number;
};

const AVFormattedCurrency = (props: AVFormattedCurrencyProps) => {
  const {formatCurrency} = useGlobalize();

  if (typeof props.value === 'number') {
    return (
      <Text nativeID={props.accessibilityLabel} {...props}>
        {formatCurrency(props.value, AccountStore.getCurrency())}
      </Text>
    );
  } else {
    return <Text {...props} />;
  }
};

export default AVFormattedCurrency;
